<template>
  <footer class="bufooter">
    <div class="bufooter-top py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div
            v-if="surrounding.address"
            class="col-6 col-md bufooter-top__col mb-3 mb-md-0 text-center"
          >
            <i class="fa fa-map-marker mb-3"></i><br />
            <h4 class="mb-2">Postadres</h4>
            <span>{{ surrounding.address.street }} {{ surrounding.address.housenumber }}</span><br />
            <span>{{ surrounding.address.postalcode }} {{ surrounding.address.city }}</span>
          </div>
          <div
            v-if="surrounding.phonenumber"
            class="col-6 col-md bufooter-top__col mb-3 mb-md-0 text-center"
          >
            <i class="fa fa-phone mb-3"></i><br />
            <h4 class="mb-2">Contact</h4>
            <span>
              <a :href="'tel:' + surrounding.phonenumber.replace(' ', '').replace('-', '')" class="text-decoration-none">{{ surrounding.phonenumber }}</a>
            </span><br />
          </div>
          <div
            v-if="surrounding.footer_logo"
            class="col-6 col-md bufooter-top__col text-center"
          >
            <img :src="getImage('footer-logo.png')" class="logo" />
          </div>
          <div
            v-if="surrounding.email"
            class="col-6 col-md bufooter-top__col text-center"
          >
            <i class="fa fa-envelope mb-3"></i><br />
            <h4 class="mb-2">Mail</h4>
            <span><a :href="'mailto:' + surrounding.email" class="text-decoration-none">{{ surrounding.email }}</a></span>
          </div>
          <div
            v-if="hasSocial"
            class="col-6 col-md bufooter-top__col text-center"
          >
            <i class="fa fa-thumbs-o-up mb-3"></i><br />
            <h4 class="mb-4">Volg ons</h4>
            <span>
                <a
                  v-if="surrounding.facebook"
                  :href="surrounding.facebook"
                  class="facebook mr-3"
                  target="_blank"
                >
                  <i class="fa fa-facebook-f"></i>
                </a>
                <a
                  v-if="surrounding.instagram"
                  :href="surrounding.instagram"
                  class="instagram mr-3"
                  target="_blank"
                >
                  <i class="fa fa-instagram"></i>
                </a>
                <a
                  v-if="surrounding.twitter"
                  :href="surrounding.twitter"
                  class="twitter"
                  target="_blank"
                >
                  <i class="fa fa-twitter-square"></i>
                </a>
              </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="images.length && surrounding.id === 546"
      class="bufooter-middle d-flex flex-nowrap justify-content-center"
    >
      <div
        v-for="(img, index) in images"
        :key="index"
        :style="{ backgroundImage: 'url(' + getImage(img) + ')' }"
        class="bufooter-middle__image"
      />
    </div>
    <div
      :style="{ backgroundColor: surrounding.style }"
      class="bufooter-bottom"
    >
      <div class="container-fluid text-center">
        <div class="bufooter-bottom__copyright py-3 text-white">
          COPYRIGHT &copy; {{ year }} {{ surrounding.name }} | Gerealiseerd door <a href="https://zakelijk.enjoj.nl" title="ENJOJ" target="_blank">ENJOJ</a>
          <span v-if="privacy"> | Lees hier onze <a :href="privacy.itemable.files.url" target="_blank">privacyverklaring</a></span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'ec-business-footer',
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    },
    privacy: {
      type: Object,
      default: null
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    hasSocial () {
      return this.surrounding.facebook || this.surrounding.instagram || this.surrounding.twitter
    },
    year () {
      return new Date().getFullYear()
    }
  },
  methods: {
    getImage (img) {
      return require('@/assets/images/' + img)
    }
  }
}
</script>
